"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTIVE_CONSUMER_REQUEST_STATUS_CODES = exports.ConsumerRequestStatus = void 0;
var ConsumerRequestStatus;
(function (ConsumerRequestStatus) {
    ConsumerRequestStatus[ConsumerRequestStatus["Scheduled"] = 65] = "Scheduled";
    ConsumerRequestStatus[ConsumerRequestStatus["Pending"] = 70] = "Pending";
    ConsumerRequestStatus[ConsumerRequestStatus["PendingApproval"] = 80] = "PendingApproval";
    ConsumerRequestStatus[ConsumerRequestStatus["PendingTenant"] = 90] = "PendingTenant";
    ConsumerRequestStatus[ConsumerRequestStatus["PendingPropertyManager"] = 100] = "PendingPropertyManager";
    ConsumerRequestStatus[ConsumerRequestStatus["Timeout"] = 101] = "Timeout";
    ConsumerRequestStatus[ConsumerRequestStatus["AcceptedProviderRequest"] = 110] = "AcceptedProviderRequest";
    ConsumerRequestStatus[ConsumerRequestStatus["RejectedProviderRequest"] = 120] = "RejectedProviderRequest";
    ConsumerRequestStatus[ConsumerRequestStatus["Cancelled"] = 130] = "Cancelled";
    ConsumerRequestStatus[ConsumerRequestStatus["DeclinedPropertyManager"] = 126] = "DeclinedPropertyManager";
})(ConsumerRequestStatus = exports.ConsumerRequestStatus || (exports.ConsumerRequestStatus = {}));
exports.ACTIVE_CONSUMER_REQUEST_STATUS_CODES = [
    ConsumerRequestStatus.Scheduled,
    ConsumerRequestStatus.Pending,
    ConsumerRequestStatus.PendingApproval,
];
